/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import { ClickToScrollOffsets, useClickToScrollEffect } from '@tock/hooks';
import { Tabs } from 'ui';
import { TabsProps } from '@material-ui/core';
import { scrollListNavigationRoot } from 'ui/ScrollListNavigation/scrollListNavigationCssDefs';

export interface ScrollListNavigationProps extends Omit<TabsProps, 'value'>, ClickToScrollOffsets {
  /**
   * overwrite the onChange to just take a value
   */
  onChange?: (value: any) => void;
  /**
   * A HTML element, component instance, or function that returns either.
   * The `container` will be what is scrolled
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `window` most of the time.
   */
  container?: React.ReactInstance | (() => React.ReactInstance | null) | null;
  /**
   * value is optional
   */
  value?: any;
  /**
   * id selector when looking for a scroll target
   */
  selector?: (value: any) => string;
}

/**
 * ScrollListNavigation is a list of ScrollListNavigationItems
 *
 * ```js
 * import { ScrollListNavigation } from 'components/business/ScrollListNavigation';
 * ```
 */
const ScrollListNavigation: React.FunctionComponent<ScrollListNavigationProps> = React.forwardRef<
  HTMLButtonElement,
  ScrollListNavigationProps
>(
  (
    {
      children,
      className,
      container,
      value,
      onChange,
      offset,
      offsetSm,
      offsetMd,
      selector = (id) => `${id}-panel`,
    },
    ref
  ) => {
    const { handleChange } = useClickToScrollEffect({
      offset,
      offsetSm,
      offsetMd,
      onChange,
      selector,
      container,
    });

    return (
      <Tabs
        ref={ref}
        contained
        className={className}
        css={scrollListNavigationRoot}
        value={value}
        variant="scrollable"
        scrollButtons="off"
        onChange={(ev: unknown, value?: any) => (value ? handleChange(value) : undefined)}
      >
        {children}
      </Tabs>
    );
  }
);
export default ScrollListNavigation;
